import * as React from "react";
import { Box } from "@mui/material";
import { ThemeProperties } from "../../../../Theme/ThemeProperties";
import { StyledTabContainer, TertiaryTab } from "../../../../Components/CustomTab";

export default function BatteryAlertsTabs({
    tabs = [],
    selectedTab,
    onChange = () => {},
}) {
    const [currentTab, setCurrentTab] = React.useState(selectedTab);

    const handleChange = (event, newValue) => {
        setCurrentTab(newValue);
        onChange(newValue);
    };

    React.useEffect(() => {
        setCurrentTab(selectedTab);
    }, [selectedTab]);


    return (
        <Box sx={{
            background: '#F9F9F9',
            borderRadius: '8px',
            minHeight: 0
        }}>
            <StyledTabContainer
                value={currentTab}
                onChange={handleChange}
                aria-label="Tertiary tabs"
                elevation={1}
                sx={{ minHeight: 0, display: 'flex', width: '100%', bgcolor: '#EAEAEA', borderRadius: '4px', mb: 2 }}
                myColor={ThemeProperties.purple}>
                {tabs.map((item) => {
                    const isActive = selectedTab === item.slug;
                    return (
                        <TertiaryTab
                            disabled={item.disabled}
                            isActive={isActive}
                            value={item.slug}
                            key={item.id}
                            label={item.name}
                            sx={{maxWidth: '100%', fontSize: '14px !important', fontWeight: isActive ? '500 !important' : '400 !important'}}
                        />
                    )
                })}
            </StyledTabContainer >
        </Box >
    );
}
